<template>
  <section id="menu" class="">
    <div class="sidebar">
      <router-link
        :to="item.route"
        v-for="item in navigation"
        :key="item.name"
        class="item"
        :class="[item.name, { selected: route == item.name }]"
      >
        <div class="name">{{ $t(item.title) }}</div>
      </router-link>

      <a
        :href="item.url"
        v-for="item in links"
        :key="item.name"
        class="item"
        target="_blank"
      >
        <div class="name">{{ $t(item.name) }}</div>
      </a>
      <div class="copyright">
        {{ $t("miclive.copyright.developed") }}<span class="heart"></span
        >{{ $t("miclive.copyright.by") }}
      </div>
    </div>
    <div class="overlay" @click="close()"></div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      navigation: [
        {
          route: "/",
          name: "home",
          title: "miclive.navigation.home"
        },
        {
          route: "/competition",
          name: "competition",
          title: "miclive.navigation.competition"
        },
        {
          route: "/teams",
          name: "teams",
          title: "miclive.team.teams"
        },
        {
          route: "/live",
          name: "live",
          title: "miclive.navigation.live"
        },
        {
          route: "/follow",
          name: "follow",
          title: "miclive.navigation.follow"
        },
        {
          route: "/facilities",
          name: "facilities",
          title: "miclive.navigation.facilities"
        },
        {
          route: "/sanctions",
          name: "sanctions",
          title: "miclive.navigation.sanctions"
        }
      ]
    };
  },
  computed: {
    route() {
      return this.$route.name;
    },
    links() {
      var result = this.$store.getters["getLinks"];
      return result;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#menu {
  width: 100%;
  height: calc(100vh - 60px);
  position: fixed;
  top: 60px;
  z-index: 100;

  .sidebar {
    width: 70%;
    height: 100%;
    display: inline-block;
    background-color: $secondary-color;
    float: left;
    padding: 15px;
    max-width: 300px;

    .item {
      width: 100%;
      padding: 10px;
      height: 40px;
      text-decoration: none;
      text-align: left;
      font-family: $font-title;
      color: $main-color;
      text-transform: uppercase;
    }

    .copyright {
      font-size: 10px;
      position: absolute;
      bottom: 10px;
      left: 10px;
      .heart {
        width: 10px;
        height: 10px;
        margin: 0 5px;
        background-size: 10px;
        background-position: center;
        background-image: url("~@/../public/img/heart.svg");
        display: inline-block;
      }
    }
  }

  .overlay {
    background-color: $main-color;
    opacity: 0.7;
    width: 100%;
    height: 100%;
    display: inline-block;

    position: fixed;
    z-index: 2;
  }
}
</style>
